import { render, staticRenderFns } from "./indexDrawer.vue?vue&type=template&id=20297e46&scoped=true"
import script from "./indexDrawer.vue?vue&type=script&lang=js"
export * from "./indexDrawer.vue?vue&type=script&lang=js"
import style0 from "./indexDrawer.vue?vue&type=style&index=0&id=20297e46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20297e46",
  null
  
)

export default component.exports